import { Navigate, Route, Routes } from 'react-router-dom';
import { api } from './api/client';
import { AuthContext } from './context/auth';
import { useAsync } from './lib/hooks';
import { AppShell } from './components/AppShell';
import { ToastProvider } from './components/Toast';
import { ErrorState, LoadingState } from './components/States';
import { Dashboard } from './pages/Dashboard';
import { Archives } from './pages/Archives';
import { ArchiveDetail } from './pages/ArchiveDetail';
import { Upload } from './pages/Upload';
import { S3Import } from './pages/S3Import';
import { Search } from './pages/Search';
import { Versions } from './pages/Versions';
import { Retention } from './pages/Retention';
import { Retrieval } from './pages/Retrieval';
import { Audit } from './pages/Audit';
import { Billing } from './pages/Billing';
import { Notifications } from './pages/Notifications';

export default function App() {
  const { status, data: me, error, reload } = useAsync(() => api.me(), []);

  if (status === 'loading') {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <LoadingState />
      </div>
    );
  }

  if (status === 'error' || !me) {
    // Not signed in -> send the browser to the OIDC login endpoint (proxied to
    // archive-service, which redirects to Keycloak). Full-page nav, no router.
    if (error?.isUnauthorized) {
      window.location.replace('/auth/login');
      return (
        <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
          <LoadingState />
        </div>
      );
    }
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24 }}>
        <ErrorState error={error!} onRetry={reload} />
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ me }}>
      <ToastProvider>
          <Routes>
            <Route element={<AppShell />}>
              <Route index element={<Dashboard />} />
              <Route path="archives" element={<Archives />} />
              <Route path="archives/:id" element={<ArchiveDetail />} />
              <Route path="upload" element={<Upload />} />
              <Route path="s3import" element={<S3Import />} />
              <Route path="search" element={<Search />} />
              <Route path="versions" element={<Versions />} />
              <Route path="retention" element={<Retention />} />
              <Route path="retrieval" element={<Retrieval />} />
              <Route path="audit" element={<Audit />} />
              <Route path="billing" element={<Billing />} />
              <Route path="notifications" element={<Notifications />} />
              {/* Admin routes deliberately live in a separate bundle/container
                  (AdminApp.tsx, deploy/charts/admin-web) — see appUrls.ts. */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
      </ToastProvider>
    </AuthContext.Provider>
  );
}
